// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import VueI18n from 'vue-i18n';
import i18next from 'i18next';
import router from './router'
import xss from 'xss'
// 加载公用样式
import '@/style/flex.css';
import '@/style/common.scss';
import '@/style/vant.scss';
import jcxyDialog from "./components/jcxy-dialog/jcxy-dialog.js";

Vue.prototype.$jcxyConfirm = jcxyDialog

Vue.config.productionTip = false

// es6语法兼容ie浏览器
import "babel-polyfill";

import 'vant/lib/index.css';
import {
  Checkbox,
  Toast,
  PullRefresh,
  Icon,
  List,
  Swipe,
  SwipeItem,
  Tag,
  Skeleton,
  Popup,
  Image,
  Picker,
  Popover,
  Tab, Tabs
} from 'vant';
Vue.use(PullRefresh);
Vue.use(Checkbox);
Vue.use(Toast);
Vue.use(Icon);
Vue.use(List);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Tag);
Vue.use(Skeleton);
Vue.use(Popup);
Vue.use(Image);
Vue.use(Picker);
Vue.use(Popover);
Vue.use(Tab);
Vue.use(Tabs);

Toast.setDefaultOptions('loading', {
  forbidClick: true
});

import '@vant/touch-emulator';

//工具类
import utils from './utils/utils.js';
utils.getUserInfo();
Vue.prototype.$utils = utils;

Vue.use(xss);
Object.defineProperty(Vue.prototype, '$xss', {
  value: xss
})// click事件被过滤

// 注册多语言
import zhCN from './i18n/zh-CN'; //中文
import en from './i18n/en'; //英文
Vue.use(VueI18n);
const i18n = new VueI18n({
  locale: 'zh-CN', // 语言标识
  messages: {
    'zh-CN': zhCN,
    'en': en
  }
});
// i18n.mergeLocaleMessage
i18next.init({
  lng: 'zh-CN',
  resources: {}
});
// 新增国际化文本
Vue.prototype.mergeLang = function(path) {
  const languageList = utils.getLanguageList();
  languageList.forEach((languageItem) => {
    let newMessages = require("@/i18n/" + path + "/" + languageItem.key) || {}
    console.log(newMessages)
    Vue.prototype.bus.$i18n.mergeLocaleMessage(languageItem.key, newMessages)
  });
}

//过滤器
import * as filters from '@/filters'; // 全局vue filter
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
});

//网络请求插件
import {
  request
} from '@/utils/httpRequest.js';
request.init();
Vue.prototype.$request = request;


router.beforeEach(function(to, from, next) {
  if (to.path == "/") {
    if (!utils.isLogin()) {
      next({
        name: "login",
        query: {
          tenantId: to.query.tenantId || "",
          return_url: encodeURIComponent(location.href)
        }
      });
    } else {
      next({
        name: "tab"
      });
    }
  } else if (to.meta.isLoginAuthority && !utils.isLogin()) { //检测该接口是否需要登录
    next({
      name: "login",
      query: {
        tenantId: to.query.tenantId || "",
        return_url: encodeURIComponent(location.href)
      }
    });
  } else {
    next();
  }
});

// 标题
import commonTitle from "@/components/commonTitle";
Vue.component("commonTitle", commonTitle);
import commonTitle2 from "@/components/commonTitle2";
Vue.component("commonTitle2", commonTitle2);
import commonTitle3 from "@/components/commonTitle3";
Vue.component("commonTitle3", commonTitle3);


//无数据布局
import viewNoData from '@/components/view-noData.vue';
Vue.component("view-noData", viewNoData);

import moreText from './components/more-text.vue'
Vue.component("more-text", moreText);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  router,
  components: {
    App
  },
  template: '<App/>',
  beforeCreate() {
    Vue.prototype.bus = this;
  }
})


// WEBPACK FOOTER //
// ./src/main.js